module.exports = __webpack_public_path__ + "static/media/199.ccb580e4.jpg";